'use es6';

import { isPositionWithinBounds } from '../geometry/basic';
const calculateBasicHoverPositions = (nodePositions, adjustedMouseCoords, config) => {
  return nodePositions.filter(nodePosition => {
    const mouseCoordinatesToCheck = {
      x: nodePosition.isFixedPosition ? adjustedMouseCoords.clientX : adjustedMouseCoords.x,
      y: nodePosition.isFixedPosition ? adjustedMouseCoords.clientY : adjustedMouseCoords.y
    };
    return isPositionWithinBounds(mouseCoordinatesToCheck, nodePosition);
  }).map(nodePosition => {
    const customFields = config.getCustomFields ? config.getCustomFields(nodePosition) : {};
    return Object.assign({
      depth: nodePosition.depth,
      id: nodePosition.id
    }, customFields);
  });
};
export default calculateBasicHoverPositions;